import { type SVGProps, useEffect, useMemo, useState } from 'react';

import FallbackDefault from '@quick/components/img/user_placeholder.svg';

import type { IImage } from './data';

function Image({ alt, src, fallback = FallbackDefault, ...props }: IImage) {
  const [Fallback, fbprops] = useMemo(() => {
    // object is included because forwardRef components are objects.
    if (typeof fallback !== 'string') return [fallback, props];
    return ['img', { ...props, src: fallback, alt: '' }];
  }, [fallback, props]);
  const [err, setErr] = useState(false);
  useEffect(() => {
    if (!src) return;
    setErr(false);
  }, [src]);
  const onError = () => {
    if (!err) setErr(true);
  };
  return err || !src ? (
    <Fallback
      className={props.className}
      {...(fbprops as SVGProps<SVGSVGElement>)}
    />
  ) : (
    <img src={src} onError={onError} alt={alt} {...props} />
  );
}
export { Image };
